import { api } from './api';

// programs: optional array of 'ccm'/'bhi' — the enrollment snapshot the link
// carries (approval auto-enrolls them). Omitted → the server derives every
// currently link-eligible program.
export async function createConsentLink(patientId, sentTo = '', programs = undefined) {
  const body = { patientId, sentTo };
  if (Array.isArray(programs) && programs.length) body.programs = programs;
  return await api.post('/api/consent-links', body);
}
export async function listConsentLinks() {
  const res = await api.get('/api/consent-links');
  return res.links || [];
}
export async function resendConsentLink(id) {
  return await api.post(`/api/consent-links/${id}/resend`, {});
}
export async function voidConsentLink(id) {
  return await api.post(`/api/consent-links/${id}/void`, {});
}
export function absoluteUrl(path) {
  return `${window.location.origin}${path}`;
}
// The ready-to-forward SMS message for a fresh consent link (mirrors the
// intake quickMint template). Shown with its own Copy button so staff can
// paste it straight into Messages.
export function consentSmsBody(practiceName, url, expiresAt) {
  const expiresAtMs = expiresAt == null || expiresAt === '' ? NaN : new Date(expiresAt).getTime();
  const days = Number.isFinite(expiresAtMs)
    ? Math.max(1, Math.ceil((expiresAtMs - Date.now()) / 86400000))
    : 7;
  const duration = days === 1 ? '1 day' : `${days} days`;
  return `Hello, this is ${practiceName || 'our office'}. Please review and approve your care-management enrollment — it takes about 2 minutes: ${url} (The link expires in ${duration}.)`;
}
